// extracted by mini-css-extract-plugin
module.exports = {"tag":"c0hp-r3","itemLink":"c2FNm2u","linkText":"x3zVuT"};